import { BaseSyntheticEvent, ReactElement } from 'react';

import { useFormController } from '@dreryk/react-common';
import { RadioGroup, StyledFlex } from '@dreryk/react-components';

import { historicalLeavesTranslationKeys } from '../../../../../translations';

import {
   DEFAULT_MEDICAL_LEAVE_ZLA_PRINT_TYPE,
   MEDICAL_LEAVE_ZLA_PRINT_TYPE_ITEMS,
} from './ForeignInsuredPrintModal.constants';
import { MedicalLeaveZlaPrintType } from './ForeignInsuredPrintModal.types';

const modalTranslationKeys = historicalLeavesTranslationKeys.foreignInsuredPrintModal;

export type ForeignInsuredPrintFormBean = {
   printType: MedicalLeaveZlaPrintType;
};

type ForeignInsuredPrintFormRenderProps = {
   handleSubmit: (
      callback: (values: ForeignInsuredPrintFormBean) => Promise<void>
   ) => (e?: BaseSyntheticEvent) => Promise<void>;
};

type ForeignInsuredPrintFormProps = {
   readonly children: (renderProps: ForeignInsuredPrintFormRenderProps) => ReactElement;
};

export const ForeignInsuredPrintForm = (props: ForeignInsuredPrintFormProps): JSX.Element => {
   const { register, handleSubmit } = useFormController<ForeignInsuredPrintFormBean>({
      printType: DEFAULT_MEDICAL_LEAVE_ZLA_PRINT_TYPE,
   });

   return (
      <>
         <StyledFlex direction={'column'} gap={'12px'}>
            <RadioGroup<MedicalLeaveZlaPrintType>
               label={modalTranslationKeys.whichDocumentTypeToPrint}
               testId={'medicalLeaveZlaPrintType'}
               items={MEDICAL_LEAVE_ZLA_PRINT_TYPE_ITEMS}
               controller={register('printType')}
               defaultValue={DEFAULT_MEDICAL_LEAVE_ZLA_PRINT_TYPE}
            />
         </StyledFlex>
         {props.children({ handleSubmit: handleSubmit })}
      </>
   );
};
